import { useServices } from "@core/servicesContext";
import { PromiseResult, usePromise } from "@utils/hooks";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { UserKyc } from "./userKyc";

export function useKyc(): PromiseResult<UserKyc> {
	const { userKycService } = useServices();
	const currentProfile = useCurrentProfile();
	return usePromise(() => userKycService.getKyc(), [currentProfile?.id]);
}
